import {
  PacketModule,
  createPacketServices
} from "./chunk-4L2KHIRB.mjs";
import "./chunk-O6L2WK4J.mjs";
export {
  PacketModule,
  createPacketServices
};
